<div *ngIf="!imagesLoaded">
  <div *transloco="let t;read: 'workers'">
    <h3 *ngIf="previewLabel">{{t('addWorkers.'+previewLabel)}}<span *ngIf="previewStar" class="text-danger">*</span>
    </h3>
    <div *ngFor="let image of previewData" class="col-6 col-sm-4 {{cssStyle}}">
      <div class="position-relative border rounded p-2 text-center">
        <img [src]="viewDocs ? image.responsePath : image.filePath" [alt]="image.name" class="img-fluid mb-2"
          style="height: 100px;">
        <button *ngIf="!acrossIcon" type="button" [id]="remove_id"
          class="position-absolute top-0 end-0 m-1 d-flex align-items-center justify-content-center"
          style="background: #CBD5E1; border: none; border-radius: 5px; opacity: 0.5; width: 24px; height: 24px; cursor: pointer;"
          (click)="removeItems(image)">
          <i class="fa-solid fa-xmark" style="font-size: 14px; color: #000;"></i>
        </button>
        <p *ngIf="image.name" class="small text-truncate mb-0">{{ image.name }}</p>
      </div>
    </div>
  </div>
</div>
<!-- <mat-spinner diameter="50" color="warn"></mat-spinner> -->

<!-- <div *ngIf="!imagesLoaded" class="text-center p-3">
  <i class="fa fa-spinner fa-spin"></i> Loading images...
</div>  -->
